import { FormGroup, FormGroupFeedback, IFormGroupProps, IInputProps, Input, Intent } from '@pinpointhq/thumbtack';
import { FieldHelperProps, FieldInputProps, FieldMetaProps, useField } from 'formik';
import * as React from 'react';

interface IEmailFieldProps {
  name: string;
  formGroupProps?: Omit<IFormGroupProps, 'labelFor'>;
  inputProps?: Omit<IInputProps, 'type' | 'intent'>;
  placeholder?: string;
}

export function EmailField<T extends string>(props: IEmailFieldProps) {
  const { name, formGroupProps, inputProps, placeholder } = props;
  const [field, meta]: [FieldInputProps<T>, FieldMetaProps<T>, FieldHelperProps<T>] = useField<T>(name);
  const hasInitialError = meta.initialError;
  const hasError = meta.touched && meta.error;
  return (
    <FormGroup {...formGroupProps} labelFor={name}>
      <Input
        fill={true}
        type="email"
        {...field}
        {...inputProps}
        placeholder={placeholder}
        intent={hasError || hasInitialError ? Intent.DANGER : Intent.NONE}
      />
      {hasError && <FormGroupFeedback intent={Intent.DANGER}>{meta.error}</FormGroupFeedback>}
      {!hasError && hasInitialError && (
        <FormGroupFeedback intent={Intent.DANGER}>{meta.initialError}</FormGroupFeedback>
      )}
    </FormGroup>
  );
}
